export const common = {
  login: '登入',
  register: '註冊',
  logout: '登出',
  confirm: '確認',
  cancel: '取消',
  submit: '提交',
  save: '儲存',
  delete: '刪除',
  edit: '編輯',
  add: '新增',
  search: '搜尋',
  loading: '載入中...',
  retry: '重新載入',
  noData: '暫無資料',
  error: '出錯了',
  success: '成功',
  back: '返回',
  next: '下一步',
  prev: '上一步',
  done: '完成',
  more: '更多',
  all: '全部',
  today: '今天',
  yesterday: '昨天',
  week: '本週',
  month: '本月',
  year: '今年',
  home: '首頁',
  market: '行情',
  lockPrice: '鎖價',
  orders: '訂單',
  profile: '我的',
  language: '語言',
  zhCN: '簡體中文',
  en: 'English',
  zhTW: '繁體中文',
  serviceTerms: '服務條款',
  privacyPolicy: '隱私政策',
  riskWarning: '風險提示',
  phone: '手機號',
  password: '密碼',
  confirmPassword: '確認密碼',
  forgotPassword: '忘記密碼?',
  noAccount: '尚未有帳號?',
  hasAccount: '已有帳號?',
  registerNow: '立即註冊',
  loginNow: '立即登入',
  placeholderPhone: '請輸入手機號',
  placeholderPassword: '請輸入密碼',
  errorPhoneEmpty: '請輸入手機號',
  errorPhoneFormat: '請輸入正確的11位手機號',
  errorPasswordEmpty: '請輸入密碼',
  errorPasswordLength: '密碼至少6位',
  errorPasswordMismatch: '兩次密碼不一致',
  errorAgreeTerms: '請同意用戶協議',
  errorInvalidCredentials: '手機號或密碼錯誤，請重試',
  errorEmailNotConfirmed: '帳號尚未驗證，請聯繫管理員',
  errorLoginFailed: '登入失敗：{{message}}',
  errorAccountExists: '該手機號已註冊，請直接登入',
  errorRateLimit: '註冊請求太頻繁了，請稍等約 1 小時後再試',
  errorRegisterFailed: '註冊失敗：{{message}} (code: {{code}}, status: {{status}})',
  errorRegisterSuccessNoLogin: '註冊成功但未自動登入，請手動登入',
  loginSuccess: '登入成功',
  registerSuccess: '註冊成功',
  welcomeLogin: '歡迎登入',
  welcomeRegister: '建立帳號',
  registerSubtitle: '開啟您的黃金投資之旅',
  agreeTerms: '我已閱讀並同意',
  userAgreement: '《用戶服務協議》',
  privacyPolicyDoc: '《隱私政策》',
  resetPasswordHint: '請聯繫客服重置密碼',
  confirmLogout: '確認登出？',
  userServiceAgreement: '用戶服務協議',
  ok: '確定',
  close: '關閉',
  copy: '複製',
  copied: '已複製',
  amount: '金額',
  date: '日期',
  status: '狀態',
  detail: '詳情',
  notice: '公告',
  viewAll: '查看全部',
  latestNotice: '最新公告',
  noNotice: '暫無公告',
  noticeLoadFailed: '公告載入失敗',
  contactCustomerService: '請聯繫客服重置密碼',
  settings: '設置',
  accountSecurity: '賬號與安全',
  notifications: '消息通知',
  general: '通用',
  changePassword: '修改登錄密碼',
  changePhone: '更換手機號',
  realNameVerify: '實名認證',
  verified: '已認證',
  verifyThenChange: '請通過驗證碼驗證後修改',
  priceAlert: '金價異動提醒',
  priceAlertDesc: '價格大幅波動時通知',
  tradeAlert: '交易狀態提醒',
  tradeAlertDesc: '鎖價、支付、交割進度',
  systemPush: '系統消息推送',
  systemPushDesc: '公告及活動信息',
  clearCache: '清除緩存',
  cacheCleared: '緩存已清除',
  about: '關於CJJY',
};